import type { SVGProps } from "react";
export default function SvgBellRing(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-bell-ring-icon lucide-bell-ring"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M10.268 21a2 2 0 0 0 3.464 0" />
			<path d="M22 8c0-2.3-.8-4.3-2-6" />
			<path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" />
			<path d="M4 2C2.8 3.7 2 5.7 2 8" />
		</svg>
	);
}
